/* eslint-disable */
import forEach from 'lodash.foreach';
import isEmpty from 'lodash.isempty';
import get from 'lodash.get';
import NotificationClient from '../../api/NotificationClient';

export default {
  state: {
    notifications: [],
    counts: {},
    pagination: {},
    appLaunchMessage: null,
  },
  mutations: {
    setNotificationResults(state, response) {
      state.notifications = response.messages;
      state.counts = response.message_counts;
      state.pagination = response.pagination;
    },
    setAllRead(state, value=true) {
      forEach(state.notifications, (notification) => {
        notification.read = value;
      });
    },
    setUnseenCount(state, count) {
      state.counts.unseen = count;
    },
    setAppLaunchMessage(state, message) {
      state.appLaunchMessage = isEmpty(message) ? null : message;
    },
  },
  actions: {
    async getAll({ commit, state }, params) {
      const notificationClient = new NotificationClient(this.state.authorization.user);
      const response = await notificationClient.getAll(params);

      commit('setNotificationResults', response.data.data);

      return response;
    },
    async getRecent({ commit }) {
      const notificationClient = new NotificationClient(this.state.authorization.user);
      const response = await notificationClient.getRecent();

      commit('setNotificationResults', response.data.data);

      return response;
    },
    async getAppLaunchMessage({ commit }) {
      const notificationClient = new NotificationClient(this.state.authorization.user);
      let responseData = null;

      const response = await notificationClient.getAppLaunchMessage();
      commit('setAppLaunchMessage', response?.data?.data);
      responseData = response?.data?.data;

      return responseData;
    },
    async markAllRead({ commit }) {
      const notificationClient = new NotificationClient(this.state.authorization.user);
      const response = await notificationClient.markAllRead();
      commit('setAllRead', true);
      return response;
    },
    async markAllSeen({ commit }) {
      const notificationClient = new NotificationClient(this.state.authorization.user);
      const response = await notificationClient.markAllSeen();

      commit('setUnseenCount', 0);

      return response;
    },
    async markRead({ commit }, notificationId) {
      const notificationClient = new NotificationClient(this.state.authorization.user);
      const response = await notificationClient.markRead(notificationId);

      return response;
    },
    clearAppLaunchMessage({ commit }) {
      commit('setAppLaunchMessage', null);
    },
  },
  getters: {
    unseenCount: state => {
      return get(state.counts, 'unseen', 0);
    },
    unseenCountDisplay: state => {
      const unseen = get(state.counts, 'unseen', 10);
      return unseen >= 10 ? '9+' : unseen;
    },
  },
};
